import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, observable, runInAction, set } from "mobx";
import { routeLocationLicenseActivationsGet, routeLocationLicenseDelete, routeLocationLicensePatch } from "@devowl-wp/api-real-commerce";
import { LicenseActivation } from "./licenseActivation.js";
import { RealCommerceError } from "../exceptions/realCommerceError.js";
import { realCommerceRequest } from "../utils/realCommerceRequest.js";
class License {
    get subscription() {
        const { subscription } = this.data;
        return subscription ? this.store.subscriptions.get(subscription.id) : undefined;
    }
    constructor(data, store){
        this.busy = false;
        this.activations = new Map();
        this.update = flow(function*(data) {
            this.busy = true;
            yield this.store.probablyRenewJwt();
            try {
                const { license: newData } = yield realCommerceRequest({
                    location: routeLocationLicensePatch,
                    request: {
                        license: {
                            licenseKey: this.data.licenseKey,
                            ...data
                        }
                    },
                    settings: {
                        headers: this.store.authorizationHeader
                    }
                });
                this.data = newData;
                // Recalculate "Products" so "usage / maxUsage" count is corrected
                this.store.fetchSubscriptions();
            } catch (e) {
                console.log(e);
                throw new RealCommerceError(e);
            } finally{
                this.busy = false;
            }
        });
        this.delete = flow(function*() {
            this.busy = true;
            yield this.store.probablyRenewJwt();
            try {
                yield realCommerceRequest({
                    location: routeLocationLicenseDelete,
                    request: {
                        license: {
                            licenseKey: this.data.licenseKey
                        }
                    },
                    settings: {
                        headers: this.store.authorizationHeader
                    }
                });
                this.store.licenses.delete(this.data.id);
                // Recalculate "Products" so "usage / maxUsage" count is corrected
                this.store.fetchSubscriptions();
            } catch (e) {
                console.log(e);
                throw new RealCommerceError(e);
            } finally{
                this.busy = false;
            }
        });
        this.fetchActivations = flow(function*() {
            this.busy = true;
            yield this.store.probablyRenewJwt();
            try {
                const { licenseActivations } = yield realCommerceRequest({
                    location: routeLocationLicenseActivationsGet,
                    params: {
                        licenseKey: this.data.licenseKey
                    },
                    settings: {
                        headers: this.store.authorizationHeader
                    }
                });
                for (const row of licenseActivations){
                    const { id } = row;
                    const existing = this.activations.get(id);
                    if (existing) {
                        set(existing.data, row);
                    } else {
                        this.activations.set(id, new LicenseActivation(row, this));
                    }
                }
                // Remove stale subscriptions
                const activeIds = licenseActivations.map(({ id })=>id);
                Array.from(this.activations.keys()).forEach((potentialStaleId)=>{
                    if (activeIds.indexOf(potentialStaleId) === -1) {
                        this.activations.delete(potentialStaleId);
                    }
                });
            } catch (e) {
                console.log(e);
                throw new RealCommerceError(e);
            } finally{
                this.busy = false;
            }
        });
        this.store = store;
        runInAction(()=>{
            this.data = data;
        });
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], License.prototype, "data", void 0);
_ts_decorate([
    observable
], License.prototype, "busy", void 0);
_ts_decorate([
    observable
], License.prototype, "activations", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], License.prototype, "subscription", null);
export { License };
